<template>
<div class="chapter">
<div class="inner_page">
<p class="ach"><em>Other titles by Laurie Graham</em></p>
<p class="acl"><em>Fiction</em></p>
<p class="acl">The Man for the Job</p>
<p class="acl">The Ten O'clock Horses</p>
<p class="acl">Perfect Meringues</p>
<p class="acl">The Dress Circle</p>
<p class="acl">Dog Days, Glenn Miller Nights</p>
<p class="acl1"><em>Non-fiction</em></p>
<p class="acl">The Parent's Survival Guide</p>
<p class="acl">The Marriage Survival Guide</p>
<p class="acl">Teenagers</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FutureHomemake_adca-1.vue?fcc1778c